import orderService from './../../../services/order';
import Vue from 'vue';
import Icon from 'vue-awesome';
import moment from 'moment';

export default {
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
    Icon,
    orderForm: require('@/components/orderForm/orderForm.vue'),
  },
  data() {
    return {
      form: {
        orderNum: '',
        orderDate: new Date(),
        items: [
          {
            refCode: '',
            title: '',
            description: '',
            quantity: 1,
            price: '',
            discountable: false,
            totalPrice: '',
          },
        ],
        images: [],
        deliveryType: null,
        deliveryPrice: 0,
        tax: 0,
        setupPrice: 0,
        deliveryAddress: '',
        deliveryPhoneNumber: '',
        deliveryDate: new Date(),
        deliveryTime: [],
        discount: 0,
        totalDiscount: 0,
        totalPrice: 0,
        customerId: null,
      },
      fileList: [],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    async onSubmit(form) {
      try {
        if (form.deliveryTime[0]) {
          form.deliveryTimeStart = moment(form.deliveryTime[0], 'HH:mm').toDate();
        }

        if (form.deliveryTime[1]) {
          form.deliveryTimeEnd = moment(form.deliveryTime[1], 'HH:mm').toDate();
        }

        const response = await orderService.create(form);
        if (response.data.error) {
          this.$message.error(response.data.error.message);
        } else {
          Vue.router.push({
            name: 'order.view',
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/order/create/index.js